export default {
    // Common
    title: 'Play',

    // Sections
    competitions: {
        title: 'Your competitions',
    },
};
